import React from 'react';
import './About.css';

const About: React.FC = () => {
  return (
    <section id="about" className="about">
      <div className="container">
        <h2>About Mohammad</h2>
        <div className="about-content">
          <div className="about-text">
            <p>
              My journey in programming began in 1998 when I discovered the
              amazing
              <strong> Casio FX-850P</strong> pocket computer. With no personal
              computer and limited internet access, I learned{" "}
              <strong>Basic</strong> programming from the manual alone. This
              early experience sparked a passion that has driven my career ever
              since.
            </p>
            <p>
              My trip through programming languages continued, but nothing truly
              captivated me until I discovered <strong>Node.js</strong>. This
              technology became the foundation of my professional expertise and
              opened doors to modern backend development.
            </p>
            <p>
              With a solid foundation in Node.js and MongoDB, my work at Repzo
              Inc. has revolved around developing and scaling robust back-end
              systems. My expertise extends to cloud solutions, including AWS
              services, where I've leveraged VPC, EC2, ECS, Lambda, DynamoDB,
              SES, SQS, and RDS for enhanced performance and reliability.
            </p>
            <p>
              Currently serving as Technical Manager at Repzo Inc., I lead
              end-to-end engineering initiatives while spearheading our AI
              transformation. I oversee Design, QA, and Project Management
              teams, ensuring alignment with product and business goals while
              building computer-vision pipelines and LangChain-based agents.
            </p>
          </div>
          <div className="about-stats">
            <div className="stat-card">
              <h3>6+</h3>
              <p>Years at Repzo Inc.</p>
            </div>
            <div className="stat-card">
              <h3>15+</h3>
              <p>Years Programming</p>
            </div>
            <div className="stat-card">
              <h3>10+</h3>
              <p>AWS Services</p>
            </div>
            <div className="stat-card">
              <h3>Civil Engineer</h3>
              <p>Background</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
